// actions/employee-onboarding/deny.js

import { attachAuth } from '../../utils/authService';
import PubSub         from 'pubsub-js';

export function denyHasErrored(bool) {
  return {
    type: 'ONBOARDING_DENY_HAS_ERRORED',
    hasErrored: bool
  };
}

export function denyIsLoading(bool) {
  return {
    type: 'ONBOARDING_DENY_IS_LOADING',
    isLoading: bool
  };
}

export function denyFetchDataSuccess(data) {
  return {
    type: 'ONBOARDING_DENY_FETCH_DATA_SUCCESS',
    data
  };
}

export function denyFetchData(host, params) {
  return (dispatch) => {
    dispatch(denyIsLoading(true));
    dispatch(denyHasErrored(false));
    fetch(host + 'approve/deny', {
      method: 'post',
      body: JSON.stringify(params),
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(denyFetchDataSuccess(result));
            dispatch(denyHasErrored(false));
            dispatch(denyIsLoading(false));
            PubSub.publish('employee.approve.deny', params);
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(denyHasErrored(true));
            dispatch(denyIsLoading(false));
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(denyHasErrored(true));
      dispatch(denyIsLoading(false));
    });
  };
}